import BigNumber from 'bignumber.js';
import { useEffect, useState } from 'react';

import { BIG_DECIMAL_18 } from '../utils/constants';
import { universeContract } from '../utils/contracts';
import useMaxMint from './useMaxMint';
import { useWeb3Context } from './useWeb3Context';


function useMintPrice(quantity: number | BigNumber) {
  const { provider } = useWeb3Context();
  const { maxMintPerTransaction } = useMaxMint();
  const [priceInEther, setPriceInEther] = useState(new BigNumber(0).toString());
  const [priceInWei, setPriceInWei] = useState(new BigNumber(0).times(BIG_DECIMAL_18).toString())
  const [priceIsInvalid, setPriceIsInValid] = useState(false)

  useEffect(() => {
    const getAmount = (amount: string | number) => {
      const valueToBN = new BigNumber(quantity)
      const validateQuantity = (valueToBN.gt(0) && quantity && maxMintPerTransaction.lt(quantity)) || isNaN(valueToBN.toNumber());
      const amountInEther = new BigNumber(amount.toString()).div(BIG_DECIMAL_18).times(validateQuantity ? 1 : quantity);
      const amountInWei = new BigNumber(amount.toString()).times(validateQuantity ? 1 : quantity);
      return {
        amountInEther,
        amountInWei,
        validateQuantity
      }
    }

    const getMintPrice = async () => {
      const publicSalePrice = await universeContract(provider).publicSalePrice();
      setPriceInWei(getAmount(publicSalePrice).amountInWei.toString())
      setPriceInEther(getAmount(publicSalePrice).amountInEther.toString());
      setPriceIsInValid(getAmount(publicSalePrice).validateQuantity);
    }

    getMintPrice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity, maxMintPerTransaction])

  useEffect(() => {
    return () => {
      setPriceInEther(new BigNumber(0).toString())
      setPriceInWei(new BigNumber(0).toString());
    };
  }, []);

  return {
    priceInEther,
    priceInWei,
    priceIsInvalid
  };
}

export default useMintPrice;